import ReportEditConfig from '@/components/reports/editconfig/ReportEditConfig.vue'

const defaultFilterValues = {
  isDeleted: [0]
};

export default {
  name: 'ReportConfigs',
  data () {
    return {
      isMounted: false,
      loading: false,
      items: {},
      currentReq: null,
      filterValues: this.BasicHelper.cloneObject(defaultFilterValues),
      editEl: null
    }
  },
  components: {
    ReportEditConfig
  },
  computed: {
    canEdit () {
      // not fully supported
      return false && this.ApiRequest.userHasPermission('edit-settings');
    },
    tableHeaders () {
      const headers = {
        reports: [
          { key: 'name', label: this.$t('report.config.columns.name'), format: 'formatTranslation' },
          { key: 'contract_material_group_id', label: this.$t('report.contract_material_group'), format: 'formatFromConfig', configKey: 'material_groups', configParam: 'name' },
          { key: 'from_date_period_id', label: this.$t('general.filters.date-period-from'), format: 'formatDatePeriod' },
          { key: 'to_date_period_id', label: this.$t('general.filters.date-period-to'), format: 'formatDatePeriod' }
        ],
        columns: [
          { key: 'name', label: this.$t('report.config.columns.name'), format: 'formatTranslation' },
          { key: 'code', label: this.$t('general.item.code') },
          { key: 'order', label: this.$t('general.item.order') },
          { key: 'measure_type_id', label: this.$t('material.measure_type'), format: 'formatFromConfig', configKey: 'measure_types', configParam: 'name' }
        ],
        costTypes: [
          { key: 'name', label: this.$t('report.config.costTypes.name'), format: 'formatTranslation' },
          { key: 'code', label: this.$t('general.item.code') },
          { key: 'order', label: this.$t('general.item.order') }
        ],
        statuses: [
          { key: 'name', label: this.$t('report.config.statuses.name'), format: 'formatTranslation' },
          { key: 'code', label: this.$t('general.item.code') },
          { key: 'order', label: this.$t('general.item.order') }
        ]
      };
      if (this.canEdit) {
        headers.reports.push(
          { key: 'actions', label: '', actions: [{ label: this.$t('menu.config.reports.costTypes.edit'), emit: 'editItem', icon: 'edit', bicon: 'pencil-fill' }] }
        );
        headers.costTypes.push(
          { key: 'actions', label: '', actions: [{ label: this.$t('menu.config.reports.costTypes.edit'), emit: 'editItem', icon: 'edit', bicon: 'pencil-fill' }] }
        );
        headers.columns.push(
          { key: 'actions', label: '', actions: [{ label: this.$t('menu.config.reports.columns.edit'), emit: 'editItem', icon: 'edit', bicon: 'pencil-fill' }] }
        );
        headers.statuses.push(
          { key: 'actions', label: '', actions: [{ label: this.$t('menu.config.reports.statuses.edit'), emit: 'editItem', icon: 'edit', bicon: 'pencil-fill' }] }
        );
      }
      return headers;
    },
    tableExpandConfig () {
      return { costTypes: { component: 'ReportCostTypeExpand' } };
    },
    tableActions () {
      const actions = { reports: {}, columns: {}, costTypes: {}, statuses: {} };
      return actions;
    },
    tableFilterConfig () {
      const filters = { };
      filters.isDeleted = { type: 'checkbox', label: this.$t('general.filters.deleted'), options: this.yesNoOptions };
      return filters;
    },
    requestPath () {
      let path = 'report/base-config';
      if (this.filterValues.isDeleted.length > 0) {
        path += '?isDeleted=' + this.filterValues.isDeleted.join(';');
      }
      return path;
    },
    yesNoOptions () {
      return this.BasicHelper.yesNoOptions();
    },
    editItemTitle () {
      if (this.editEl) {
        return this.$t('menu.config.reports.' + this.editEl.type + '.edit');
      }
      return '';
    },
    measureTypeOptions () {
      const options = this.$store.getters.getConfigOptions('measure_types', this.$i18n.locale);
      options.unshift({ code: null, text: '' });
      return options;
    }
  },
  methods: {
    getTableData () {
      if (this.currentReq) {
        this.currentReq.cancel('changed search query');
      }
      this.loading = true;
      this.BasicHelper.updateFilterValues(this.$route.name, this.filterValues);
      const self = this;
      this.currentReq = this.ApiRequest.request(this.requestPath, this.ApiRequest.REQUEST_GET, {}, function (response) {
        if (response.data) {
          self.items = response.data;
          self.loading = false;
        }
      });
    },
    editItem (el, type) {
      if (type === 'reports') {
        this.$refs.editReportConfig.show(el);
      } else {
        this.editEl = this.BasicHelper.cloneObject(el);
        if (type === 'columns') {
          if (this.editEl.measure_type_id) {
            this.editEl.measure_type = this.$store.getters.getParamFromConfig('measure_types', this.editEl.measure_type_id, 'code');
          } else {
            this.editEl.measure_type = null;
          }
        }
        this.editEl.type = type;
        this.$refs.editItemFrm.show();
      }
    },
    saveEditEl () {
      this.loading = true;
      const reqData = {
        name: this.editEl.name,
        code: this.editEl.code,
        order: this.editEl.order,
        type: this.editEl.type
      };
      if (this.editEl.type === 'columns') {
        reqData.measure_type = this.editEl.measure_type;
      }
      const self = this;
      this.ApiRequest.request('report/config', this.ApiRequest.REQUEST_POST, { item: reqData }, function (response) {
        if (response.error) {
          self.ApiRequest.displayErrorDialog(response);
          self.loading = false;
        } else {
          self.getTableData()
          self.$refs.editItemFrm.hide();
        }
      });
    },
    closeEditEl () {
      this.$refs.editItemFrm.hide();
      this.editEl = null;
    },
    configUpdated () {
      this.$store.dispatch('loadConfig');
      this.getTableData();
    }
  },
  mounted () {
    this.filterValues = this.BasicHelper.fillFilterValues(this.$route.name, this.filterValues, this.$session);
    this.isMounted = true;
    this.getTableData();
  }
}
